import type { LocationType } from '@/domain/client';
import { isLandbasedLocation, isSmoltLocation } from '@/utils/locationTypeHelpers';

/**
 * What this location calls a pen, as a default-namespace translation key.
 *
 * The same ternary used to sit in the row and the link cell, and the column
 * header needed a third copy. Named once so a location type added later changes
 * one place, and so the header can never disagree with the tooltip below it.
 */
export function penLabelKey(
    locationType: LocationType
): 'common.labels.cage' | 'common.labels.tank' {
    return isSmoltLocation(locationType) || isLandbasedLocation(locationType)
        ? 'common.labels.tank'
        : 'common.labels.cage';
}
